const faLocale = {
    Today: "امروز",
    back: "بازگشت",
};

export default faLocale;
